<script setup lang="ts">
import type { PropertyGroupOption } from "@shopware-pwa/types";
import ColorOptionCircleButton from "~/templates/elements/ColorOptionCircleButton.vue";

export interface ProductVariantColorOptionProps {
  option?: PropertyGroupOption;
}

const { option } = defineProps<ProductVariantColorOptionProps>();

const { product } = useProduct();

const isOptionNotCombinable = computed(
  (): boolean => option?.extensions?.combinable?.combinable === false,
);
const isOptionSelected = computed(() => product.value?.optionIds?.includes(option.id));
const isOptionNotAvailable = computed(
  (): boolean => !product.value.available && isOptionSelected.value,
);
</script>

<template>
  <ColorOptionCircleButton
    :is-option-not-available="isOptionNotAvailable || isOptionNotCombinable"
    :is-option-selected="isOptionSelected"
    :option="option"
  />
</template>
